module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-auth-box d-flex justify-center align-center",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "g-auth-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.showForgot && false) ? _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('div', {
    staticClass: "pax-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgot.email),
      expression: "forgot.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.forgot.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendForgot($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgot.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.forgot.error) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.forgot.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-success login-btn",
    on: {
      "click": _vm.sendForgot
    }
  }, [_vm._v("SEND FORGOT PASSWORD")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "cnl-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancelForgot
    }
  }, [_vm._v("Cancel")])])]) : _c('div', [_c('email-mobile-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user.token),
      expression: "!user.token"
    }],
    on: {
      "loginUser": _vm.loginUser,
      "nonUser": _vm.nonUser,
      "getUserInfo": _vm.getUserInfo,
      "hideVeriForm": _vm.hideVeriForm
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fbd0606a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbd0606a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/GlobalLogin.vue
// module id = 2153
// module chunks = 0